import { RegistrationService } from 'services/main/endpoints/RegistrationService';
import { createToast, createErrorToast } from './createToast';
import imageCompression from 'browser-image-compression';
import * as Sentry from '@sentry/react';
//const MAX_FILE_SIZE = 5 * 1024 * 1024;
const INITIAL_DELAY = 5000;
const RETRIES = 3;

const delay = ms => new Promise(res => setTimeout(res, ms));

const retryUpload = async (uploadFn, setToastList, retries = RETRIES, delayMs = INITIAL_DELAY, cookie) => {
  try {
    if (retries < 1) {
      createErrorToast(setToastList, `Muitas tentativas de upload.`);
      Sentry.captureMessage('Chamado - muitas tentativas de upload', {
        tags: { Empresa: cookie?.companies?.id },
      });
      throw new Error('Muitas tentativas de upload.');
    }
    return await uploadFn();
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401) {
      createErrorToast(setToastList, `Token invalido`);
      Sentry.captureMessage('Chamado - upload, token invalido', {
        tags: { Empresa: cookie?.companies?.id },
      });
      throw new Error('Token invalido');
    }
    await delay(delayMs);
    return retryUpload(uploadFn, setToastList, retries - 1, delayMs);
  }
};

const handleImageUpload = async (imageData, mediaType, empresaId, token, setToastList, compress = true, cookie) => {
  if (!imageData || typeof imageData === 'string') {
    return imageData;
  }
  let file = imageData.file;
  const fileExtension = file.name.split('.').pop().toLowerCase();
  const allowedExtensions = ['jpg', 'jpeg', 'png'];

  if (!allowedExtensions.includes(fileExtension)) {
    createErrorToast(setToastList, 'Formato de arquivo não suportado.');
    Sentry.captureMessage('Chamado - formato de arquivo não suportado', {
      tags: { Empresa: cookie?.companies?.id },
    });
    throw new Error('Formato de arquivo não suportado.');
  }

  // 🔒 Valida tamanho máximo
  // if (file.size > MAX_FILE_SIZE) {
  //   createErrorToast(setToastList, `O arquivo excede o tamanho máximo permitido de 5MB.`);
  //   throw new Error('O arquivo excede o tamanho máximo permitido de 5MB.');
  // }

  // 🔄 Compressão condicional
  if (compress) {
    try {
      const options = {
        //maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        initialQuality: 0.9,
      };

      const compressedFile = await imageCompression(file, options);

      file = new File([compressedFile], file.name, { type: compressedFile.type });
    } catch (err) {
      console.error('Erro ao comprimir imagem:', err);
    }
  }

  // 🔄 Criar toast de carregamento
  const loadingToast = createToast({
    type: 'loading',
    message: 'Estamos abrindo seu chamado...',
  });
  setToastList(prev => [...prev, loadingToast]);

  // 🔹 Função real de upload
  const doUpload = async () => {
    const response = await RegistrationService.uploadSignature({
      filePath: imageData.cloudPath,
      file,
      token,
    });
    if (response.status === 401) {
      throw new Error('Token inválido');
    }
    return response;
  };

  try {
    const response = await retryUpload(doUpload, setToastList, cookie);
    return response;
  } catch (error) {
    createErrorToast(setToastList, error.message || 'Erro ao fazer upload da imagem.');
    throw error;
  } finally {
    setToastList(prev => prev.filter(t => t.id !== loadingToast.id));
  }
};

export { handleImageUpload };
